
import { defineComponent, PropType } from 'vue'
import { IVacancy } from '@tokyojob/core'
import { getLocalization } from '@tokyojob/frontend-components'
import CVacancyDetailCard from './c-vacancy-detail-card.component.vue'
import { VacancyDetailCardFactory } from './factory/vacancy-detail-card.factory'
import { getProvidedApp } from '~/base/utils/provided-getter'

export default defineComponent({
  components: {
    CVacancyDetailCard,
  },
  props: {
    vacancy: {
      type: Object as PropType<IVacancy>,
      required: true,
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  setup(props) {
    const localization = getLocalization(getProvidedApp())
    const vacancyDetailCards = VacancyDetailCardFactory.getAll(localization, props.vacancy)
    return {
      vacancyDetailCards,
    }
  },
})
